var _path;

var _excluded = ["size"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    height: size,
    width: size
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M485.2 463.2L386 364c68.8-80 65.6-201.6-11.2-278.4-40-40-92.8-59.2-144-59.2-52.8 0-104 19.2-144 59.2-80 80-80 209.6 0 289.6 40 40 92.8 59.2 144 59.2 46.4 0 94.4-16 132.8-48l99.2 99.2 22.4-22.4zm-376-110.4c-67.2-67.2-67.2-176 0-243.2 32-33.6 75.2-51.2 121.6-51.2s89.6 17.6 121.6 51.2c67.2 67.2 67.2 176 0 243.2-32 32-75.2 51.2-121.6 51.2s-89.6-17.6-121.6-51.2z"
  })));
};

export default SvgSearch;